export default (length: number, message: string) => (value: string): string | boolean => {
  if (!value) {
    return true;
  }
  return value.length > length || message;
};
